<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/QXAyh9/images/Cover.jpg?1708005252238" alt="This image is the cover for the book Oregon Search & Rescue, Brief History"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Oregon Search & Rescue, Brief History
      </h1>
      <p class="bookDescription body article font2">
        <p>Oregon's long tradition of volunteer search and rescue dates back to the territorial days, when Good Samaritans and mountain men came to aid those in need. On the coast, surfmen of the U.S. Life-Saving Service protected mariners traversing the "Graveyard of the Pacific." In the early twentieth century, outdoor clubs like the Mazamas, the Skyliners and the Obsidians served as informal search and rescue units, keeping Oregonians safe in the mountains, rivers and wilderness areas. After World War II, Oregon's volunteer teams began to professionalize and became some of the most effective units in the country. Join author Glenn Voelz as he recounts the history of Oregon search and rescue.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Glenn Voelz
      </h2>
      
      <p class="authorDescription body article">Glenn Voelz served for twenty-five years in the U.S. Army as an intelligence officer. He held senior leadership positions at the Pentagon, in the White House and at NATO headquarters. He is a graduate of West Point and served on the faculty as an assistant professor in the Department of History. He is the author of more than a dozen books and journal articles and works as a professional ski patroller at the Mount Bachelor Nordic Center and a volunteer with Deschutes County Sheriff's Office Search and Rescue.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The History Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?22b78313